// Einfache Aufstellung ohne Nachdenken: für das Harness (C) und als Startvorschlag beim Aufstellen.
// Nahkämpfer vorn, das Dickfell ganz vorn, das Eichhörnchen mit Baum in der Mitte, Fernkämpfer hinten.
import { combatRules, getSpecies } from '../../content/index.ts';
import { combatProfile } from './profile.ts';
import { friendById, type Placement } from './run.ts';
import type { RunState } from './types.ts';

export function autoPlace(run: RunState, ids: string[], mirrorY = false): Placement[] {
  const z = combatRules.field.friendZone;
  const h = combatRules.field.height;
  const rows: Record<'front' | 'mid' | 'back', string[]> = { front: [], mid: [], back: [] };
  for (const id of ids) {
    const f = friendById(run, id);
    const prof = combatProfile(f, run);
    if (getSpecies(f.species).passive === 'baumhaus') rows.mid.push(id);
    else if (prof.stats.range > 10) rows.back.push(id);
    else rows.front.push(id);
  }
  const x = { front: z.xMax - 6, mid: (z.xMin + z.xMax) / 2, back: z.xMin + 14 };
  const out: Placement[] = [];
  for (const row of ['front', 'mid', 'back'] as const) {
    const list = rows[row];
    list.forEach((id, i) => {
      const y = ((i + 1) / (list.length + 1)) * h;
      out.push({ id, x: x[row] - (row === 'front' && friendById(run, id).friendClass !== 'dickfell' ? 4 : 0), y: mirrorY ? h - y : y });
    });
  }
  return out;
}
